// eslint-disable-next-line import/extensions
import majors from './majors.json'

export const MAJORS: string[] = majors
